<template>
    <div v-if="isOpen" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
        <h3>Editor</h3>
        <button class="close-btn" @click="closeModal"><span class="material-symbols-outlined">
            fullscreen_exit</span>
        </button>
        </div>
        <div class="modal-body">
          <codemirror
            v-model="editorCode"
            :extensions="extensions"
            style="height: 400px;"
          />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { Codemirror } from 'vue-codemirror';
  import { html } from "@codemirror/lang-html";
  import { css } from "@codemirror/lang-css";
  import { EditorView } from '@codemirror/view';
 

  export default {
    name: 'EditorModal',
    components: {
      Codemirror,
    },
    props: {
      code: {
        type: String,
        default: '',
      },
      isOpen: {
        type: Boolean,
        required: true,
      },
      editorMode: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        mode: this.editorMode,
        editorCode: this.code
      };
    },
    computed: {
      extensions() {
        return this.editorMode === 'html' ? [html(), EditorView.lineWrapping] : [css(), EditorView.lineWrapping];
    }},
    methods: {
      closeModal() {
        this.$emit('close');
      },
    },
    watch: {
      editorCode(newCode) {
        this.$emit('updateCode', newCode); // Sende aktualisierte Daten an die Eltern-Komponente
      },
    },
  };
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background-color: white;
    width: 80%;
    max-width: 800px;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
  
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .close-btn {
    background-color: transparent;
    border: none;
    font-size: 20px;
    cursor: pointer;
  }

  .pretty-code-button {
  margin-top: 10px;
  padding: 5px 10px;
  border: none;
  background-color: #f1f1f1;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.pretty-code-button:hover {
  background-color: #ddd;
}
  </style> 
 